import { AxiosError, AxiosRequestConfig } from 'axios';
import { apiDelete, apiGet, apiPost, apiPut } from '../api';

import {
  IOrganizationConfig,
  IOrganizationConfigCreate,
  IProductConfigAdditionalActionConfirmDto,
  IProductConfiguration,
  IProductConfigurationCreate,
  IProductConfigurationUpdateReseller
} from '../../types/product.configuration.types';

const { REACT_APP_SUBSCRIPTION } = process.env;

export const getOrganizationConfigByOrganizationId = async (organizationId: number): Promise<IOrganizationConfig[]> => {
  return apiGet<AxiosRequestConfig, IOrganizationConfig[]>(
    `${REACT_APP_SUBSCRIPTION}/organization-config/by-organization/${organizationId}`
  )
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const getOrganizationConfigTableByOrganizationId = async (
  organizationId: number,
  filtersQuery: string,
  searchText: string
): Promise<IOrganizationConfig[]> => {
  return apiGet<AxiosRequestConfig, IOrganizationConfig[]>(
    `${REACT_APP_SUBSCRIPTION}/organization-config/table-by-organization/${organizationId}?${filtersQuery}&search=${searchText}`
  )
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const addOrganizationConfig = async (
  createOrganizationConfigData: IOrganizationConfigCreate
): Promise<IOrganizationConfig> => {
  const formData = new FormData();
  const dataJson = JSON.stringify({
    organizationId: createOrganizationConfigData.organizationId,
    configClassId: createOrganizationConfigData.configClassId,
    name: createOrganizationConfigData.name || '',
    configData: createOrganizationConfigData.configData
  });
  formData.append('data', dataJson);
  if (createOrganizationConfigData.file) {
    formData.append('file', createOrganizationConfigData.file);
  }
  return apiPost<AxiosRequestConfig, FormData>(`${REACT_APP_SUBSCRIPTION}/organization-config`, formData)
    .then(resp => Promise.resolve(resp.data))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const getProductConfigurationByProductId = async (productId: number): Promise<IProductConfiguration[]> => {
  return apiGet<AxiosRequestConfig, IProductConfiguration[]>(
    `${REACT_APP_SUBSCRIPTION}/product-config/by-product/${productId}`
  )
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const addProductConfiguration = async (config: IProductConfigurationCreate): Promise<IProductConfiguration> => {
  return apiPost<AxiosRequestConfig, IProductConfigurationCreate>(`${REACT_APP_SUBSCRIPTION}/product-config`, config)
    .then(resp => Promise.resolve(resp.data))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const updateConfigurationStatus = async (isActive: boolean, uuid: string): Promise<boolean> => {
  return apiPut<AxiosRequestConfig, { isActive: boolean }>(
    `${REACT_APP_SUBSCRIPTION}/organization-config/update-active-status/${uuid}`,
    {
      isActive
    }
  )
    .then(resp => Promise.resolve(resp.data))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const updateProductConfigurationReseller = async (
  config: IProductConfigurationUpdateReseller
): Promise<IProductConfiguration> => {
  return apiPut<AxiosRequestConfig, IProductConfigurationUpdateReseller>(
    `${REACT_APP_SUBSCRIPTION}/product-config/reseller`,
    config
  )
    .then(resp => Promise.resolve(resp.data))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const confirmConfigAdditionalAction = async (
  config: IProductConfigAdditionalActionConfirmDto
): Promise<string> => {
  return apiPut<AxiosRequestConfig, IProductConfigAdditionalActionConfirmDto>(
    `${REACT_APP_SUBSCRIPTION}/product-config-additional-actions/backoffice/confirm`,
    config
  )
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const deleteConfiguration = async (uuid: string): Promise<boolean> => {
  return apiDelete<AxiosRequestConfig, { uuid: string }>(`${REACT_APP_SUBSCRIPTION}/organization-config/delete/${uuid}`)
    .then(resp => Promise.resolve(resp.data))
    .catch((error: AxiosError) => Promise.reject(error));
};
